import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  href?: string;
  target?: string;
  onLinkClick?: () => void;
};
export function Button({
  children,
  className = '',
  href,
  target,
  onLinkClick,
  ...props
}: ButtonProps) {
  const style = `inline-flex items-center justify-center rounded-full bg-green px-7 py-4 text-sm font-bold text-white shadow-[0_8px_18px_rgba(21,128,61,.2)] transition-colors hover:bg-green-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-green ${className}`;
  return href ? <motion.a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} onClick={onLinkClick} whileHover={{
    scale: 1.025
  }} whileTap={{
    scale: 0.98
  }} className={style} data-id="element-37" data-mp="288cqz1oc15n4">
      {children}
    </motion.a> : <motion.button {...props} whileHover={{
    scale: 1.025
  }} whileTap={{
    scale: 0.98
  }} className={style} data-id="element-38" data-mp="2vxxhc5mtf56f">
      {children}
    </motion.button>;
}